const Payments = {

    // PAGE HEADER
    "payment": "Payment",
    "charges": "Charges",
    "search": "Search",

    // TABLE HEADER
    "table_payment_date": "PAYMENT DATE",
    "table_amount": "AMOUNT",
    "table_receipt_no": "RECEIPT NO",
    "table_payment_mode": "PAYMENT MODE",
    "table_status": "STATUS",
    "table_remarks": "REMARKS",
    "table_charge_name": "CHARGE NAME",
    "table_create_date": "CREATE DATE",
    "table_charge_date": "CHARGE DATE",
    "table_expiry_date": "EXPIRY DATE",
    "table_invoice_no": "INVOICE NO",

}

export default Payments;
